import { UsersReduxState } from "./reducer";

export const persistStore = async (
  state: UsersReduxState,
): Promise<UsersReduxState> => ({ ...state });
